import { Record } from 'immutable';

const BankAccountOverdraftRecord = Record({
  equivalentAnnualRate: 0,
  estimatedCost: 0,
});

export default class BankAccountOverdraft extends BankAccountOverdraftRecord {
  static deserialize(jsonObject = {}) {
    return new BankAccountOverdraft(jsonObject);
  }
}
